export default "__VITE_ASSET__98521f9e__"